import React from 'react';

interface CustomModalProps {
  isOpen: boolean;
  title: string;
  message: string;
  buttons?: Array<{id: string, text: string, type?: string}>;
  onClose: (buttonId: string) => void;
}

export const CustomModal: React.FC<CustomModalProps> = ({ isOpen, title, message, buttons, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <div className="modal-header">
          {title}
        </div>
        <div className="modal-content">
          <p>{message}</p>
        </div>
        <div className="modal-footer">
          {buttons && buttons.length > 0 ? (
            buttons.map((button) => (
              <button 
                key={button.id} 
                className={`modal-button ${button.type === 'destructive' ? 'destructive' : button.type === 'cancel' ? 'cancel' : 'primary'}`}
                onClick={() => onClose(button.id)}
              >
                {button.text}
              </button>
            ))
          ) : (
            <button className="modal-button primary" onClick={() => onClose('ok')}>
              Закрыть
            </button>
          )}
        </div>
      </div>
    </div>
  );
}; 